import React, { useContext, useMemo } from 'react';

import { AddToCart } from '@thd-olt-component-react/add-to-cart';
import { Col } from '@thd-olt-component-react/grid';
import { Button } from '@thd-olt-component-react/button';
import { ExperienceContext } from '@thd-nucleus/experience-context';

import { usePromoCart } from '../../../../contexts/PromoCartProvider';
import { usePromoModel } from '../../../../contexts/PromoModelProvider';
import { buildAddToCartRequest, buildAddToCartOverlayOptions } from '../../../../utils/promo-cart-utils';

import './PromoAddItemsToCart.scss';

export const PromoAddItemsToCart = () => {
  const { store, channel } = useContext(ExperienceContext);
  const {
    bogoSelectedProduct, promoCartItemsObj, freeItemInCart, isCartLoading, setIsCartLoading
  } = usePromoCart();
  const { anchorItem, anchorItemId, isBogo, products } = usePromoModel();

  const freeProductInfo = products.get(freeItemInCart?.itemId);
  const selectedItem = freeProductInfo || bogoSelectedProduct;

  const addToCartOptions = useMemo(() => {
    const overrides = {
      bogo: bogoSelectedProduct ? {
        itemDetails: {
          itemId: bogoSelectedProduct.itemId,
        }
      } : null,
      hidden: false,
      sharedSection: isBogo ? 'bogo' : 'multi-sku bulk',
      component: 'add both',
    };

    return buildAddToCartOverlayOptions(channel, overrides);
  }, [channel, bogoSelectedProduct, isBogo]);

  const addToCartReqParams = useMemo(() => {
    if (!bogoSelectedProduct) return [];

    const { CartRequest: anchorCartItem } = buildAddToCartRequest({
      product: anchorItem,
      promoItemModel: promoCartItemsObj[anchorItemId],
      desiredQuantity: 1,
      store
    });

    const { CartRequest: freeCartItem } = buildAddToCartRequest({
      product: bogoSelectedProduct,
      promoItemModel: promoCartItemsObj[bogoSelectedProduct.itemId],
      desiredQuantity: 1,
      store
    });

    return [].concat(anchorCartItem.itemDetails, freeCartItem.itemDetails);
  }, [anchorItem, anchorItemId, bogoSelectedProduct, store, promoCartItemsObj]);

  return (
    <>
      {selectedItem && (
        <Col fallback={12} flatten className="promo-add-items u__bold">
          {freeItemInCart && (
            <Button
              className=""
              outline
              dark
              tag="a"
              href="/mycart/home"
            >
              Go to Cart
            </Button>
          )}
          {!freeItemInCart && (
            <AddToCart
              cartReqParams={addToCartReqParams}
              cartOptions={addToCartOptions}
              disabled={isCartLoading}
              onClick={() => setIsCartLoading(true)}
              onError={() => setIsCartLoading(false)}
              onFail={() => setIsCartLoading(false)}
              onSuccess={() => setIsCartLoading(false)}
            >
              Add Both to Cart
            </AddToCart>
          )}
        </Col>
      )}
    </>
  );
};

PromoAddItemsToCart.displayName = 'PromoAddItemsToCart';
